import { Directive, input } from '@angular/core';
import { CdkMenuTrigger } from '@angular/cdk/menu';
import { PS_DROPDOWN_MENU_POSITIONS } from '../dropdown-menu-positions.constants';

/** Wraps CDK `CdkMenuTrigger` with `ps-` bindings; see `components/dropdown/README.md`. */
@Directive({
  selector: '[psDropdownTriggerFor]',
  standalone: true,
  hostDirectives: [
    {
      directive: CdkMenuTrigger,
      inputs: [
        'cdkMenuTriggerFor: psDropdownTriggerFor',
        'cdkMenuPosition: psDropdownMenuPosition',
        'cdkMenuTriggerData: psDropdownTriggerData',
        'cdkMenuTriggerTransformOriginOn: psDropdownTransformOriginOn',
      ],
      outputs: [
        'cdkMenuOpened: psDropdownOpened',
        'cdkMenuClosed: psDropdownClosed',
      ],
    },
  ],
  host: {
    class: 'ps-dropdown-trigger dropdown-toggle',
  },
})
export class PsDropdownTriggerForDirective {
  public readonly psDropdownMenuPosition = input(PS_DROPDOWN_MENU_POSITIONS);
}
